import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API } from "@/lib/api";

export default function BrandPreviewPage() {
  const { profileId } = useParams();
  const [profile, setProfile] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    fetch(`${API}/branding/public/${profileId}`)
      .then((r) => { if (!r.ok) throw new Error("not found"); return r.json(); })
      .then(setProfile)
      .catch(() => setNotFound(true));
  }, [profileId]);

  useEffect(() => {
    if (!profile?.has_favicon) return;
    const link = document.createElement("link");
    link.rel = "icon";
    link.href = `${API}/branding/public/${profileId}/image/favicon`;
    document.head.appendChild(link);
    return () => document.head.removeChild(link);
  }, [profile, profileId]);

  if (notFound) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-500 text-sm" data-testid="brand-preview-not-found">
        Branding-Vorschau nicht gefunden.
      </div>
    );
  }
  if (!profile) {
    return <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-400 text-sm italic">Lädt…</div>;
  }

  const primary = profile.primary_color || "#00CCC9";
  const accent = profile.accent_color || "#0A0A0A";
  const logoSrc = profile.has_logo ? `${API}/branding/public/${profileId}/image/logo` : null;
  const bgSrc = profile.has_background ? `${API}/branding/public/${profileId}/image/background` : null;

  return (
    <div className="min-h-screen" style={{ background: accent }} data-testid="brand-preview-page">
      <div className="px-4 pt-3">
        <div className="max-w-5xl mx-auto text-center text-[10px] font-mono text-white/40 uppercase tracking-overline">
          Branding-Vorschau · nur zu Demonstrationszwecken
        </div>
      </div>
      <div className="min-h-[calc(100vh-32px)] flex items-center justify-center p-6">
        <div
          className="w-full max-w-md relative overflow-hidden border border-white/10"
          style={{
            background: bgSrc ? `url(${bgSrc}) center/cover no-repeat` : "rgba(255,255,255,0.03)",
          }}
          data-testid="brand-preview-card"
        >
          <div className="backdrop-blur-sm bg-black/30 p-10">
            {logoSrc ? (
              <img src={logoSrc} alt="Logo" className="h-10 w-auto mb-6" data-testid="brand-preview-logo" />
            ) : (
              <div className="h-10 flex items-center mb-6 text-white font-heading text-xl font-light tracking-tighter">
                {profile.company_name || "Ihr Firmenname"}
              </div>
            )}
            <div className="text-[10px] font-bold uppercase tracking-overline text-white/60">Portal · Login</div>
            <h1 className="font-heading text-4xl font-light tracking-tighter text-white leading-[0.95] mt-2">
              Willkommen<br />zurück.
            </h1>
            <div className="mt-8 space-y-3">
              <div className="h-11 border border-white/20 bg-white/5" />
              <div className="h-11 border border-white/20 bg-white/5" />
            </div>
            <button
              type="button"
              className="w-full mt-5 py-3.5 text-sm font-semibold text-[#0A0A0A]"
              style={{ background: primary }}
              data-testid="brand-preview-cta"
            >
              Anmelden
            </button>
            <div className="mt-8 text-[11px] text-white/50 leading-relaxed" data-testid="brand-preview-footer">
              {profile.footer_text || "Firmenname · Musterstraße 1 · 12345 Musterstadt"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
